/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const NavBarIcon: React.SFC = () => {
    return (
        <svg width="31" height="27" viewBox="0 0 31 27" xmlns="http://www.w3.org/2000/svg">
            <title>Nav / icon / dashboard</title>
            <defs>
                <path d="M4 8h6v3H4v3L0 9.5 4 5v3z" id="a" />
            </defs>
            <g fill="none" fillRule="evenodd">
                <path d="M7.832 20h18.336c.546-1.248.832-2.603.832-4 0-5.523-4.477-10-10-10S7 10.477 7 16c0 1.397.286 2.752.832 4z" stroke="#555A77" strokeWidth="2" />
                <path d="M16.5 19.5l2-7" stroke="#555A77" strokeWidth="2" strokeLinecap="round" />
                <g strokeLinecap="square" transform="translate(1 5)">
                    <use fill="#555A77" xlinkHref="#a" />
                    <path stroke="#FFF" d="M4.5 7.5h6v4h-6v3.815L-.67 9.5 4.5 3.685V7.5z" />
                </g>
            </g>
        </svg>

    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/NavBar/NavBar.tsx